import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../Layout"
import UnidadesForm from "../modais/UnidadesForm"
class UnidadesCreateForm extends Component {
  constructor() {
    super()
    this.onSubmitSucess = this.onSubmitSucess.bind(this)
  }
  onSubmitSucess() {
    this.props.history.push("/unidades")
  }
  render() {
    return (
      <Layout tabActive="Unidades orçamentárias">
        <UnidadesForm callBackUnidades={this.onSubmitSucess} />
      </Layout>
    )
  }
}
export default withRouter(UnidadesCreateForm)



// WEBPACK FOOTER //
// ./src/views/unidades-orcamentarias/UnidadesCreateForm.js